import i18n from '@/utils/i18n'

export function getQuestionStatusLabel (item) {
  if (!item) return '-'
  const answer = String(item.answer || '').trim()
  if (answer) return i18n.t('support.statusAnswered')
  if (Number(item.status) === 1) return i18n.t('support.statusAnswered')
  return i18n.t('support.statusPending')
}

export function isQuestionAnswered (item) {
  return getQuestionStatusLabel(item) === i18n.t('support.statusAnswered')
}

export function toQuestionContentHtml (text) {
  if (!text) return ''
  const value = String(text)
  if (/<[a-z][\s\S]*>/i.test(value)) return value
  return value.replace(/\n/g, '<br>')
}
